import { BLACK_700, BLACK_900, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getSectionHeader1WidgetStyles = (props, isSmallScreen) => {
  var imageUrl = props.imageUrl,
    titleColor = props.titleColor;
  var imageSize = isSmallScreen ? 96 : 112;
  return StyleSheet.create({
    container: {
      width: '100%',
      flexDirection: 'row'
    },
    textContainer: Object.assign({
      alignItems: 'center',
      paddingRight: tokens.spacing.SPACING_12,
      flexDirection: 'row',
      flex: 1
    }, !imageUrl && {
      width: '100%'
    }),
    titleText: {
      color: titleColor ? titleColor : BLACK_900
    },
    desc: {
      marginTop: tokens.spacing.SPACING_4,
      color: BLACK_700
    },
    imageContainer: {
      alignSelf: 'center'
    },
    imageStyle: {
      height: imageSize,
      width: imageSize
    }
  });
};